export class GetChildPriceModel {
    intParentCodeNo: number
    intLinkNo: number
    intLinkType: number
    sglLinkCost: number
    strLinkFix: string
    sglLinkUnit: number
    lngPetNo: number
    strChkCost: string
    intClinicNo: number

    constructor(
        intParentCodeNo: number,
        intLinkNo: number,
        intLinkType: number,
        sglLinkCost: number,
        strLinkFix: string,
        sglLinkUnit: number,
        lngPetNo: number,
        strChkCost: string,
        intClinicNo: number
    ) {
        this.intParentCodeNo = intParentCodeNo
        this.intLinkNo = intLinkNo
        this.intLinkType = intLinkType
        this.sglLinkCost = sglLinkCost
        this.strLinkFix = strLinkFix
        this.sglLinkUnit = sglLinkUnit
        this.lngPetNo = lngPetNo
        this.strChkCost = strChkCost
        this.intClinicNo = intClinicNo
    }
}